import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-bulk-delete-dialog',
  templateUrl: './bulk-delete-dialog.component.html',
  styleUrls: ['./bulk-delete-dialog.component.scss']
})
export class BulkDeleteDialogComponent implements OnInit {
  images: any;

  constructor(private matDialogRef: MatDialogRef<any>) { }

  ngOnInit() {
    this.images = this.matDialogRef.componentInstance.images;
  }
}
